import axios from "axios";
import React, { useEffect, useState } from "react";

import SweetAlert from '../sweet-alert/html';
import Swal from '../sweet-alert/sweet-alert';
import { convertPersianDigits } from "../utils/convertDigits";
import { toast } from 'react-toastify'
import ImgTick from './tick.png'

//
import Flg_Algeria from './flags/Algeria.jpg'
import Flg_Austria from './flags/Austria.jpg'
import Flg_Bahrain from './flags/Bahrain.jpg'
import Flg_Denmark from './flags/Denmark.jpg'
import Flg_Egypt from './flags/Egypt.jpg'
import Flg_France from './flags/France.jpg'
import Flg_Germany from './flags/Germany.jpg'
import Flg_Iran from './flags/Iran.jpg'
import Flg_Iraq from './flags/Iraq.jpg'
import Flg_Italy from './flags/Italy.jpg'
import Flg_Jordan from './flags/Jordan.jpg'
import Flg_Kuwait from './flags/Kuwait.jpg'
import Flg_Lebanon from './flags/Lebanon.jpg'
import Flg_Libya from './flags/Libya.jpg'
import Flg_Oman from './flags/Oman.jpg'
import Flg_Qatar from './flags/Qatar.jpg'
import Flg_Saudi_Arabia from './flags/Saudi_Arabia.jpg'
import Flg_Sweden from './flags/Sweden.jpg'
import Flg_Syria from './flags/Syria.jpg'
import Flg_Tunisia from './flags/Tunisia.jpg'
import Flg_Turkey from './flags/Turkey.jpg'
import Flg_United_Arab_Emirates from './flags/United_Arab_Emirates.jpg'
import Flg_United_States from './flags/United_States.jpg'
import './style.css'
import AutoChat from "../autoChat";

const FormGetNumber = (props) => {
	const countries = [{
		img: Flg_Algeria,
		code: '+213',
		Ar_name: 'الجزائر',
		En_name: 'Algeria',
		placeholder: '-- --- ----',
		minLength: 9,
		maxLength: 9,
	}, {
		img: Flg_Austria,
		code: '+43',
		Ar_name: 'النمسا',
		En_name: 'Austria',
		placeholder: '(---) --- ----',
		minLength: 10,
		maxLength: 10,
	}, {
		img: Flg_Bahrain,
		code: '+973',
		Ar_name: 'البحرین',
		En_name: 'Bahrain',
		placeholder: '---- ----',
		minLength: 8,
		maxLength: 8,
	}, {
		img: Flg_Denmark,
		code: '+45',
		Ar_name: 'الدانمارک',
		En_name: 'Denmark',
		placeholder: '-- -- -- --',
		minLength: 8,
		maxLength: 8,
	}, {
		img: Flg_Egypt,
		code: '+20',
		Ar_name: 'مصر',
		En_name: 'Egypt',
		placeholder: '(---) --- ----',
		minLength: 10,
		maxLength: 10,
	}, {
		img: Flg_France,
		code: '+33',
		Ar_name: 'فرنسا',
		En_name: 'France',
		placeholder: '(---) --- ---',
		minLength: 9,
		maxLength: 9,
	}, {
		img: Flg_Germany,
		code: '+49',
		Ar_name: 'ألمانیا',
		En_name: 'Germany',
		placeholder: '(----) --- ----',
		minLength: 11,
		maxLength: 11,
	}, {
		img: Flg_Iran,
		code: '+98',
		Ar_name: 'إيران',
		En_name: 'Iran',
		placeholder: '(---) --- ----',
		minLength: 10,
		maxLength: 10,
	}, {
		img: Flg_Iraq,
		code: '+964',
		Ar_name: 'العراق',
		En_name: 'Iraq',
		placeholder: '(---) --- ----',
		minLength: 10,
		maxLength: 10,
	}, {
		img: Flg_Italy,
		code: '+39',
		Ar_name: 'إیطالیا',
		En_name: 'Italy',
		placeholder: '(---) ---- ---',
		minLength: 10,
		maxLength: 10,
	}, {
		img: Flg_Jordan,
		code: '+962',
		Ar_name: 'الأردن',
		En_name: 'Jordan',
		placeholder: '- ---- ----',
		minLength: 9,
		maxLength: 9,
	}, {
		img: Flg_Kuwait,
		code: '+965',
		Ar_name: 'الکویت',
		En_name: 'Kuwait',
		placeholder: '---- ----',
		minLength: 8,
		maxLength: 8,
	}, {
		img: Flg_Lebanon,
		code: '+961',
		Ar_name: 'لبنان',
		En_name: 'Lebanon',
		placeholder: '-- --- ---',
		minLength: 8,
		maxLength: 8,
	}, {
		img: Flg_Libya,
		code: '+218',
		Ar_name: 'لیبیا',
		En_name: 'Libya',
		placeholder: '-- --- ---',
		minLength: 8,
		maxLength: 8,
	}, {
		img: Flg_Oman,
		code: '+968',
		Ar_name: 'عُمان',
		En_name: 'Oman',
		placeholder: '-- --- ---',
		minLength: 8,
		maxLength: 8,
	}, {
		img: Flg_Qatar,
		code: '+974',
		Ar_name: 'قطر',
		En_name: 'Qatar',
		placeholder: '---- ----',
		minLength: 8,
		maxLength: 8,
	}, {
		img: Flg_Saudi_Arabia,
		code: '+966',
		Ar_name: 'العربیه السعودیه',
		En_name: 'Saudi Arabia',
		placeholder: '- --- ----',
		minLength: 8,
		maxLength: 8,
	}, {
		img: Flg_Sweden,
		code: '+46',
		Ar_name: 'السوید',
		En_name: 'Sweden',
		placeholder: '-- --- ----',
		minLength: 9,
		maxLength: 9,
	}, {
		img: Flg_Syria,
		code: '+963',
		Ar_name: 'سوریا',
		En_name: 'Syria',
		placeholder: '-- ---- ---',
		minLength: 9,
		maxLength: 9,
	}, {
		img: Flg_Tunisia,
		code: '+216',
		Ar_name: 'تونس',
		En_name: 'Tunisia',
		placeholder: '-- --- ---',
		minLength: 8,
		maxLength: 8,
	}, {
		img: Flg_Turkey,
		code: '+90',
		Ar_name: 'ترکیا',
		En_name: 'Turkey',
		placeholder: '(---) --- ----',
		minLength: 10,
		maxLength: 10,
	}, {
		img: Flg_United_Arab_Emirates,
		code: '+971',
		Ar_name: 'الإمارات العربیه المتحده',
		En_name: 'United Arab Emirates',
		placeholder: '- --- ----',
		minLength: 8,
		maxLength: 8,
	}, {
		img: Flg_United_States,
		code: '+1',
		Ar_name: 'الولایات المتحده',
		En_name: 'United States',
		placeholder: '(---) --- ----',
		minLength: 10,
		maxLength: 10,
	}]

	const [formLoading, setFormLoading] = useState(false)
	const [Disabled, setDisabled] = useState(true)
	const [currentCode, setCurrentCode] = useState(countries[8])
	const [Value, setValue] = useState('7')

	function changeCountry(props) {
		setCurrentCode(props)
		setValue('')
		setTimeout(() => {
			Swal.close()
		}, 200)
	}
	const CountryModal = () => {
		SweetAlert({
			allowOutsideClick: false,
			width: '100vw',
			html: (
				<>
					<ul className="countries_list">
						{countries.length > 0 ? countries.map((item, key) =>
							<li key={key} className={currentCode.En_name === item.En_name ? 'is-active' : ''}
								onClick={() => changeCountry(item)}
							>
								<div className="display_flex align_items_center">
									<img src={item.img} />
									<span className="Ar_name">{item.Ar_name}</span>
								</div>
								<div className="display_flex align_items_center" dir="ltr">
									<span className="En_name">{item.En_name}</span>&nbsp;
									<span className="code">({item.code})</span>
								</div>
							</li>
						) : null}
					</ul>
				</>
			),
		});
	}

	useEffect(() => {
		if (Value.length >= currentCode?.minLength && Value.length <= currentCode?.maxLength) {
			setDisabled(false)
		} else { setDisabled(true) }
	}, [Value])

	const onChangeInput = (e) => {
		let EnNumbers = convertPersianDigits(e.target.value)
		const result = EnNumbers.replace(/\D/g, '')
		let withoutZero = result.indexOf('0') === 0 || result.indexOf('۰') === 0 ? result.substring(1) : result;
		if (withoutZero.length <= currentCode.maxLength) {
			setValue(withoutZero)
		}
	}

	// تشخیص شماره غیرواقعی
	// const getRepeatedChars = (str) => {
	// 	const chars = {};
	// 	for (const s of str) {
	// 		chars[s] = (chars[s] || 0) + 1
	// 	}
	// 	let res = Object.entries(chars).filter(char => char[1] > 3).map((x) => {
	// 		return {
	// 			value: x[0],
	// 			repeat: x[1],
	// 		}
	// 	})
	// 	// console.log(res);
	// 	// if(res.length > 1) {
	// 	// 	for (let i = 0; i < res.length; i++) {
	// 	// 		// let string = ''

	// 	// 	}
	// 	// }

	// 	return 1
	// }

	const hasRepeatedNumber = arr => {
		const prev = {
			element: null,
			count: 0
		}
		for (let i = 0; i < arr.length; i++) {
			const { count, element } = prev;
			if (count === 4 && element === arr[i]) {
				return true;
			}
			prev.count = element === arr[i] ? count + 1 : count;
			prev.element = arr[i];
		}
		return false;
	};

	const handleSubmit = async () => {
		setFormLoading(true)
		// let DuplicateCharacters = getRepeatedChars(Value)
		let isRealNumber = hasRepeatedNumber(Value.split(''))
		if (!isRealNumber) {
			await loginBayan()
			let token = localStorage.getItem('token')
			if (token) {
				const headers = { 'Authorization': token }
				let viewmodel = {
					city_id: 1,
					country_code: Number(currentCode.code),
					phone: Value,
					description: `المشترک ${localStorage.getItem('phoneNumber')} - landing10 channel`
				}
				AutoChat(viewmodel.country_code, viewmodel.phone,props.user)
				await axios.post('https://bayan.gosnalban.com/back/public/api/landing/customer', viewmodel, {
					headers: headers
				})
					.then(response => {
						if (response.status === 201) {
							SetAlert()
						}
					}).catch(function (error) {
						if (error.response) {
							toast.error(error.response.data.data.errorMessages[0])
						}
					})
			}
		} else {
			toast.error('رقم الهاتف ليس صحيحا')
		}
		setTimeout(() => {
			setFormLoading(false)
		}, 100);
	}

	async function loginBayan() {
		let loginValues = {
			phone: '07888888881',
			password: ':73u"3=MC98e;Qc?'
		}
		await axios.post('https://bayan.gosnalban.com/back/public/api/login', loginValues)
			.then(response => {
				localStorage.setItem('token', `Bearer ${response.data.data.token}`)
			});
	}

	const Spinner = () => (<div className="spinner">
		<div className="bounce1"></div>
		<div className="bounce2"></div>
		<div className="bounce3"></div>
	</div>)

	const SetAlert = () => {
		SweetAlert({
			allowOutsideClick: true,
			html: (
				<>
					<img src={ImgTick} alt="" />
					<h3>تم تسجيل رقم هاتفك. </h3>
					<p>انتظر مكالمة من خبرائنا.</p>
					<div>
						<button className="button green mb-0 " onClick={() => Swal.close()}>حسنًا..!</button>
					</div>
				</>
			),
		});
	}

	return <>
		<div className={`form_with_selectCountry ${props.expanded ? 'expanded' : ''}`}>
			<div className="input_shape">
				<button type="button" className="code_wrapper" onClick={() => CountryModal()}>
					<img src={currentCode.img} alt='' />
					{currentCode.code}
				</button>
				<input type='tel' autoComplete="off" placeholder={currentCode.placeholder}
					onChange={onChangeInput}
					value={Value}
					min={currentCode.minLength}
					max={currentCode.maxLength}
				/>
			</div>
			<button
				id="CTA_0000"
				type='button'
				className='button expanded green radius mb-0 has_icon'
				disabled={Disabled}
				onClick={() => handleSubmit()}
			>
				{formLoading ? <Spinner /> : 'ارسل رقمك'}

			</button>
		</div>
	</>
}
export default FormGetNumber